import {
  SectionElement,
  defineElement,
  onClick,
  query,
  queryAll,
  wait
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XS5WIYU5.js";

// src/sections/shop-contact-form/shop-contact-form.ts
var ShopContactForm = class extends SectionElement {
  constructor() {
    super(...arguments);
    this.step = 1;
  }
  onContinueClick(elm) {
    return __async(this, null, function* () {
      let valid = true;
      this.inputs.forEach((input) => {
        if (!input.validity.valid) {
          valid = false;
          this.classList.add("error");
        }
      });
      if (valid && this.step === 1) {
        elm.setAttribute("loading", "");
        yield this.createHubspotDeal();
        elm.removeAttribute("loading");
        this.step = 2;
        this.classList.remove("error");
        this.firstStep.classList.add("opacity-0");
        yield wait(300);
        this.classList.remove("first-step");
        this.classList.add("second-step");
      }
    });
  }
  createHubspotDeal() {
    return __async(this, null, function* () {
      var _a, _b, _c, _d, _e;
      const params = new URLSearchParams(window.location.search);
      try {
        yield fetch("https://europe-west3-hubspot-sync-e9ad4.cloudfunctions.net/syncContactData", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            name: this.firstname.value + " " + this.lastname.value,
            email: this.mail.value,
            phone: this.phone.value,
            referrer: document.referrer,
            utm: {
              utmSource: (_a = params.get("utm_source")) != null ? _a : void 0,
              utmMedium: (_b = params.get("utm_medium")) != null ? _b : void 0,
              utmCampaign: (_c = params.get("utm_campaign")) != null ? _c : void 0,
              utmTerm: (_d = params.get("utm_term")) != null ? _d : void 0,
              utmContent: (_e = params.get("utm_content")) != null ? _e : void 0
            }
          })
        });
      } catch (e) {
        console.error(e);
      }
    });
  }
  addNoteToDeal(elm) {
    return __async(this, null, function* () {
      elm.setAttribute("loading", "");
      yield fetch("https://europe-west3-hubspot-sync-e9ad4.cloudfunctions.net/addNotesToDeal", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: this.firstname.value + " " + this.lastname.value,
          email: this.mail.value,
          note: this.text.value
        })
      });
      elm.removeAttribute("loading");
    });
  }
};
__decorateClass([
  query("[data-first-step]")
], ShopContactForm.prototype, "firstStep", 2);
__decorateClass([
  queryAll("[data-input]")
], ShopContactForm.prototype, "inputs", 2);
__decorateClass([
  query('[name="contact[first_name]"]')
], ShopContactForm.prototype, "firstname", 2);
__decorateClass([
  query('[name="contact[last_name]"]')
], ShopContactForm.prototype, "lastname", 2);
__decorateClass([
  query('[name="contact[email]"]')
], ShopContactForm.prototype, "mail", 2);
__decorateClass([
  query('[name="contact[phone]"]')
], ShopContactForm.prototype, "phone", 2);
__decorateClass([
  query('[name="contact[text]"]')
], ShopContactForm.prototype, "text", 2);
__decorateClass([
  onClick("[data-continue]")
], ShopContactForm.prototype, "onContinueClick", 1);
__decorateClass([
  onClick("[data-submit]")
], ShopContactForm.prototype, "addNoteToDeal", 1);
ShopContactForm = __decorateClass([
  defineElement("shop-contact-form")
], ShopContactForm);
export {
  ShopContactForm
};
